export const BRAND = "R K Scrap Enterprise";
export const PHONE_DISPLAY = "+91 99804 17093";
export const PHONE_TEL = "tel:+919980417093";
export const WA_NUMBER = "919980417093";
export const HOURS = "Open All Days · Response in < 60 min";

export const waLink = (
  message = "Hi, I want to sell scrap. Please share details."
) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

// Fires the Google Ads conversion event on click (does not hijack navigation)
export const reportConversion = () => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-18385193645/NbVTCIK5ueIcEK2V375E",
      value: 1.0,
      currency: "INR",
    });
  }
};

export const IMAGES = {
  hero: "https://arscrapenterprises.in/assets/hero-scrap-CiNdF5-w.jpg",
};

export const CATEGORIES = [
  {
    id: "copper",
    name: "Copper Scrap Buyers",
    desc: "Top market rates for copper wires, cables, rods & sheets across Bangalore.",
    img: "https://arscrapenterprises.in/assets/copper-D16T8CF8.jpg",
    position: "object-center",
  },
  {
    id: "aluminum",
    name: "Aluminum Scrap Buyers",
    desc: "Aluminum sheets, utensils, sections & profiles bought at premium prices.",
    img: "https://arscrapenterprises.in/assets/aluminum-B1wDTiiF.jpg",
    position: "object-center",
  },
  {
    id: "brass",
    name: "Brass Scrap Buyers",
    desc: "Brass fittings, taps, parts & turnings — instant cash on weighing.",
    img: "https://arscrapenterprises.in/assets/brass-CfSm3xg-.jpg",
    position: "object-center",
  },
  {
    id: "ss",
    name: "SS Scrap Buyers",
    desc: "Stainless steel sheets, vessels & industrial SS scrap collected free.",
    img: "https://arscrapenterprises.in/assets/ss-DQHvLT3m.jpg",
    position: "object-center",
  },
  {
    id: "ms",
    name: "MS Scrap Buyers",
    desc: "Mild steel rods, pipes, plates and structural MS scrap from sites.",
    img: "https://arscrapenterprises.in/assets/ms-Ch6Rm40q.jpg",
    position: "object-center",
  },
  {
    id: "office",
    name: "Office Scrap Buyers",
    desc: "Bulk office clearance — IT scrap, furniture, fixtures end-to-end.",
    img: "https://arscrapenterprises.in/assets/office-DmPvaAz8.jpg",
    position: "object-center",
  },
  {
    id: "furniture",
    name: "Office Furniture Scrap",
    desc: "Workstations, chairs, partitions, cabinets — dismantling included.",
    img: "https://arscrapenterprises.in/assets/furniture-v0VnmhWb.jpg",
    position: "object-center",
  },
  {
    id: "electrical",
    name: "Electrical Scrap",
    desc: "Wires, panels, transformers, switchgear and electrical components.",
    img: "https://arscrapenterprises.in/assets/electrical-L8ePjypa.jpg",
    position: "object-center",
  },
  {
    id: "battery",
    name: "Battery Scrap",
    desc: "Lead-acid, UPS, inverter & industrial batteries at honest weights.",
    img: "https://arscrapenterprises.in/assets/battery-CPuyBT4W.jpg",
    position: "object-center",
  },
  {
    id: "machinery",
    name: "Machinery Scrap",
    desc: "Old machines, motors and dismantled industrial equipment lifted free.",
    img: "https://arscrapenterprises.in/assets/machinery-B3YxxAqp.jpg",
    position: "object-center",
  },
  {
    id: "generator",
    name: "Generator Scrap",
    desc: "Diesel gensets — running or condemned, full unit dismantling & pickup.",
    img: "https://arscrapenterprises.in/assets/generator-C7e6RwCu.jpg",
    position: "object-center",
  },
  {
    id: "ac",
    name: "AC Scrap",
    desc: "Window, split & central AC units — copper, compressor & body recovery.",
    img: "https://arscrapenterprises.in/assets/ac-CTGi1aay.jpg",
    position: "object-center",
  },
  {
    id: "industrial",
    name: "Industrial Scrap",
    desc: "Factory, plant & warehouse industrial scrap clearance in bulk.",
    img: "https://arscrapenterprises.in/assets/industrial-BEiJj__t.jpg",
    position: "object-center",
  },
  {
    id: "demolition",
    name: "Building Demolition Scrap",
    desc: "Full demolition scrap pickup — MS, wood, fittings, doors, windows.",
    img: "https://arscrapenterprises.in/assets/demolition-fLUIICdj.jpg",
    position: "object-center",
  },
];

export const TRUST_ITEMS = [
  "Best Price Guaranteed",
  "Cash on Spot",
  "Free Pickup",
  "Same-Day Payment",
  "Transparent Weighing",
  "10+ Years Experience",
  "All Bangalore Covered",
  "Bulk Scrap Specialists",
];

export const SERVICE_AREAS = [
  "Whitefield",
  "HSR Layout",
  "Electronic City",
  "Sarjapur",
  "Koramangala",
  "Marathahalli",
  "Indiranagar",
  "Hebbal",
  "Yelahanka",
  "JP Nagar",
  "BTM Layout",
  "Bommanahalli",
];

export const REVIEWS = [
  {
    name: "Ravi K.",
    area: "Office Manager, Whitefield",
    text: "Cleared an entire 8,000 sqft office in two days. Honest weighing and the price beat three other quotes.",
  },
  {
    name: "Suresh M.",
    area: "Factory Owner, Bommasandra",
    text: "We've worked with R K Scrap Enterprise for 4 years. Reliable team, transparent rates, payment always on the same day.",
  },
  {
    name: "Anita R.",
    area: "Homeowner, HSR Layout",
    text: "Picked up old AC, batteries and aluminum the same evening I called. Polite team, fair rates.",
  },
  {
    name: "Naveen P.",
    area: "Procurement, Electronic City",
    text: "Bulk IT and furniture scrap handled professionally. Documentation and pickup were smooth.",
  },
];

export const FAQS = [
  {
    q: "Do you provide free pickup?",
    a: "Yes — pickup is completely free anywhere in Bangalore, for both small household loads and large industrial clearances.",
  },
  {
    q: "Which scrap materials do you buy?",
    a: "Copper, aluminum, brass, SS, MS, office & IT scrap, furniture, electrical scrap, batteries, machinery, generators, AC units, industrial and building demolition scrap — all types, one trusted buyer.",
  },
  {
    q: "Do you offer same-day payment?",
    a: "Yes, always. We pay on the spot by cash, UPI or bank transfer — before we leave your site.",
  },
  {
    q: "Which Bangalore areas do you cover?",
    a: "All of Bangalore, with fast response in Whitefield, HSR Layout, Electronic City, Sarjapur, Koramangala, Marathahalli, Indiranagar, Hebbal, Yelahanka, JP Nagar, BTM Layout and Bommanahalli.",
  },
  {
    q: "Is there a minimum quantity?",
    a: "No. From a single AC unit to a full factory clearance, we handle loads of every size with the same transparent process.",
  },
  {
    q: "Do you handle office demolition?",
    a: "Yes. Our crews handle office demolition, dismantling and complete scrap clearance end-to-end, with proper documentation.",
  },
];
